import React, { Component, Fragment, createRef } from 'react'
import { InstalledApplicationModel, EditInstalledApplicationModel, InvocationSchedulesModel, InvocationSchedulesHealthModel, ReportsInstalledApplication, FrequencyDetails, FrequencyDetailsHealth } from './models'
import { DeleteResponseModel, DropdownItemModel, DropdownItemModelReport } from '../../../../shared/models'
import { InstalledApplicationService } from './services/installed.application.service';
import { CommonService } from '../../../../shared/services/common.service';
import { HttpResponse } from '../../../../core';
import { ShowSuccessMessage, HandleNotFoundResponse, ShowWarningMessage, ShowErrorMessage } from '../../../../shared/helpers';
import { ButtonType } from '../../../../shared/enums/button.enum';
import { Link, NavLink, Route } from "react-router-dom";
import { Loader } from '../../../../shared/loaders';
import { Editor } from '../../../../shared';
import { InstalledApplicationTabs } from './InstalledApplicationTabs'
import { ValidateYaml } from '../../../../shared/helpers/yaml.helper';
import { NotFoundResponseArea } from '../../../../shared/enums';
import { ReportFormPopup } from '..';
import { Modal } from 'react-bootstrap';
import { IsAuthorize } from '../../../../shared/authorization/check-access';
import { Role } from '../../../../shared/authorization/enums';
import { ApplicationsFormPopup } from '../../../individual/applications';
import { AccountFormPopup } from '../../../accounts';
import { ReportListResponseModel } from '../models';
import { FrequencyFormPopup, FrequencySelection } from './FrequencyFormPopup';
import { InvocationSchedulesService } from '../../../individual/applications/invocation-schedules/services/invocation-schedule.service';
import { InvocationHealthSchedulesService } from '../../../individual/applications/invocation-health-schedules/services/invocation-health-schedule.service';
import { getFrequencyText } from '../../../../shared/helpers/frequency.text.helper';
import moment from 'moment';



const USE_MOCK = false;
interface IState {
    showApplicationForm?: boolean;
    installedApplication?: InstalledApplicationModel,
    getUserReportsList?: InstalledApplicationModel,
    editInstalledApplication?: EditInstalledApplicationModel,
    reportsInstalledApplication?: ReportsInstalledApplication,
    id?: number;
    name?: string;
    account_id?: number;
    report_account_id?: number;
    report_id?: number;
    application_id?: number;
    enabled?: boolean;
    run_on_report_change?: boolean;
    billable?: boolean;
    invocation_schedules?: Array<InvocationSchedulesModel>;
    invocation_schedules_health?: Array<InvocationSchedulesHealthModel>;
    frequency_list?: Array<FrequencySelection>;
    revealable_options?: string;
    options?: string;

    reportList?: DropdownItemModelReport[],
    reportName?: string,
    accountList?: DropdownItemModel[],
    accountName?: string,
    applicationList?: DropdownItemModel[],
    applicationName?: string,

    nameError?: string,
    accountError?: string,
    reportError?: string,
    applicationError?: string,
    isShowtext?: string;
    isSave?: string;
    isSaving?: boolean;

    invocationScheduleName?: string;
    invocationScheduleId?: number;
    invocationScheduleEditedId?: number;

    selectedSchedule?: any | null;

    invocationSchedulesError?: string;

    invocationScheduleHealthName?: string;
    invocationScheduleHealthId?: number;
    invocationScheduleHealthEditedId?: number;

    invocationSchedulesHealthError?: string;

    revealableOptionsError?: string;

    showReportForm?: boolean;
    showAccountForm?: boolean;
    showFreqForm?: boolean;
    isNew?: boolean;
    isChildUpdate?: boolean;
}
export class InstalledApplicationsForm extends Component<any, IState> {
    //declaring service type
    private service: InstalledApplicationService;
    private serviceInvocationSchedActions: InvocationSchedulesService;
    private serviceInvocationHealthActions: InvocationHealthSchedulesService;
    private commonService: CommonService;
    private nameRef: any;

    private roleNetworkCall: any;
    private NetworkCall: any;

    constructor(props) {
        super(props)
        this.service = new InstalledApplicationService();
        this.serviceInvocationSchedActions = new InvocationSchedulesService();
        this.serviceInvocationHealthActions = new InvocationHealthSchedulesService();
        this.commonService = new CommonService();
        this.state = this.initialState;
        this.editorhandleChangeReveableOptions = this.editorhandleChangeReveableOptions.bind(this);
        this.editorhandleChangeOptions = this.editorhandleChangeOptions.bind(this);
        this.nameRef = createRef();
        this.updateReport = this.updateReport.bind(this);
        this.updateApplication = this.updateApplication.bind(this);
        this.updateAccount = this.updateAccount.bind(this);

    }

    initialState: Partial<IState> = {
        installedApplication: {
            id: 0,
            name: "",
            application_id: 0,
            report_id: 0,
            billable: true,
            run_on_report_change: false,
            enabled: false,
            invocation_schedules: [],
            invocation_schedules_health: [],
            options: "",
            revealable_options: ""
        },
        id: 0,
        name: "",
        application_id: 0,
        account_id: 0,
        report_account_id: 0,
        report_id: 0,
        billable: true,
        run_on_report_change: false,
        enabled: false,
        invocation_schedules: [],
        invocation_schedules_health: [],
        frequency_list: [],
        options: "",
        revealable_options: "",
        reportList: [],
        reportName: "",
        applicationName: "",
        accountName: "",
        applicationList: [],
        nameError: "",
        reportError: "",
        applicationError: "",
        isShowtext: "New",
        isSave: "",
        isSaving: false,
        invocationScheduleName: "",
        invocationScheduleId: 0,
        invocationScheduleEditedId: 0,
        invocationSchedulesError: "",
        invocationScheduleHealthName: "",
        invocationScheduleHealthId: 0,
        invocationScheduleHealthEditedId: 0,
        invocationSchedulesHealthError: "",
        revealableOptionsError: "",
        showApplicationForm: false,
        showReportForm: false,
        isNew: false,
        isChildUpdate: false
    }

    updateApplication(isChildUpdate, name, id) {
        this.setState({ isChildUpdate: isChildUpdate, applicationName: name, application_id: id })
    }

    handleCloseApplication = () => {
        this.setState({ showApplicationForm: false }, () => {
        });
    }

    handleShowApplication = () => {
        this.setState({ showApplicationForm: true, isNew: true }, () => {

        });
    }

    handleShowEditApplication = () => {
        this.setState({ showApplicationForm: true, isNew: false }, () => {

        });
    }

    componentDidMount() {
        if (this.props.match.params.id > 0) {
            this.setState({ id: this.props.match.params.id, isShowtext: "Edit" }, () => {
                this.loadData();
            });
        }
        document.addEventListener('mousedown', this.handleClickOutside)

    }

    componentWillUnmount() {
        document.removeEventListener('mousedown', this.handleClickOutside);
    }

    handleClickOutside = (event) => {
        // Use event.composedPath() if available, otherwise fallback to event.path or empty array
        const path = event.composedPath ? event.composedPath() : (event.path || []);

        // Handle the reportName/report
        if (path[0] && path[0].id !== 'reportName' && path[0].id !== 'report' &&
            (event.clientX < event.target.clientWidth || event.clientY < event.target.clientHeight)) {
            this.setState({
                reportList: []
            });
        }

        // Handle the applicationName/application
        if (path[0] && path[0].id !== 'applicationName' && path[0].id !== 'application' &&
            (event.clientX < event.target.clientWidth || event.clientY < event.target.clientHeight)) {
            this.setState({
                applicationList: []
            });
        }

        // Handle the reportName/report
        if (path[0] && path[0].id !== 'accountName' && path[0].id !== 'acount' &&
            (event.clientX < event.target.clientWidth || event.clientY < event.target.clientHeight)) {
            this.setState({
                accountList: []
            });
        }

    };

    updateAccount(isChildUpdate, name, id) {
        this.setState({
            isChildUpdate: isChildUpdate,
            accountName: name,
            account_id: id,
        });
    }

    updateReport(isChildUpdate, name, id) {
        this.setState({ isChildUpdate: isChildUpdate, reportName: name, report_id: id })
    }

    handleClose = () => {
        this.setState({ showReportForm: false }, () => {
        });
    }

    handleCloseAccount = () => {
        this.setState({ showAccountForm: false }, () => {
        });
    }
    handleCloseFreqForm = () => {
        this.setState({
            showFreqForm: false,
            selectedSchedule: null,
        });
    }
    handleShowReport = () => {
        this.setState({ showReportForm: true, isNew: true }, () => {

        });
    }
    handleShowAccount = () => {
        this.setState({ showAccountForm: true, isNew: true }, () => { });
    };
    handleShowFreqModal = () => {
        this.setState({ showFreqForm: true, isNew: true }, () => { });
    };
    handleShowEditAccount = () => {
        this.setState({ showAccountForm: true, isNew: false }, () => { });
    };

    handleShowEditReport = () => {
        this.setState({ showReportForm: true, isNew: false }, () => {

        });
    }

    loadData() {
        this.service.editInstalledApplication(this.props.match.params.id)
            .then((res: HttpResponse<EditInstalledApplicationModel>) => {
                if (res && res.result) {
                    let invocationSchedules = Array<InvocationSchedulesModel>();
                    let invocationSchedulesHealth = Array<InvocationSchedulesHealthModel>();
                    let frequencyList: FrequencySelection[] = [];

                    res.result?.invocation_schedules?.forEach(p => {
                        // create a daily as default
                        let freq: FrequencyDetails = {
                            frequency: "daily",
                            days_of_month: [],
                            days_of_week: [],
                            week_of_month: "",
                            time_of_day: moment(p.run_at_time, "HH:mm").format("hh:mm A"),
                        };
                        // store schedule
                        invocationSchedules.push({
                            id: p.id,
                            run_at_time: p.run_at_time,
                            installed_report_application_id: p.installed_report_application_id,
                            tempId: p.id,
                            frequency_details: p.frequency_details ? { ...p.frequency_details } : { ...freq },
                        });
                    });
                    res.result?.invocation_schedules_health?.forEach(p => {
                        let freq: FrequencyDetails = {
                            frequency: "daily",
                            days_of_month: [],
                            days_of_week: [],
                            week_of_month: "",
                            time_of_day: "",
                        };
                        invocationSchedulesHealth.push({
                            id: p.id, report_health: p.report_health, installed_report_application_id: p.installed_report_application_id,
                            tempId: p.id,
                            frequency_details: p.frequency_details ? { ...p.frequency_details } : { ...freq },
                        })
                    })
                    this.setState({
                        billable: res.result?.billable,
                        applicationName: res.result?.application.text,
                        application_id: res.result?.application.value,
                        accountName: res.result?.account?.text ?? "",
                        account_id: res.result?.account?.value ?? undefined,
                        reportName: res.result?.report.text,
                        report_id: res.result?.report.value,
                        name: res.result?.name,
                        id: res.result?.id,
                        run_on_report_change: res.result?.run_on_report_change,
                        enabled: res.result?.enabled,
                        invocation_schedules: invocationSchedules,
                        frequency_list: frequencyList,
                        invocation_schedules_health: invocationSchedulesHealth,
                        options: res.result?.options == null ? "" : res.result?.options,
                        revealable_options: res.result?.revealable_options == null ? "" : res.result?.revealable_options
                    }, () => {
                        //use report_id to fetch account details
                        const reportId = res.result?.report?.value;
                        if (reportId) {
                            const filters = [{ name: "id", op: "eq", value: reportId }];
                            this.service.getUserReportsList(filters)
                                .then((res: HttpResponse<ReportListResponseModel>) => {
                                    const account = res.result?.records?.[0];
                                    this.setState({
                                        accountName: account?.account_name ?? "",
                                        account_id: account?.account_id ?? 0,
                                    });
                                })
                                .catch(err => {
                                    this.setState({ account_id: 0 });
                                });
                        }
                    });
                }
            })
            .catch(ex => {
                HandleNotFoundResponse(ex, NotFoundResponseArea.InstalledApplications, this.props)
            });
    }

    editorhandleChangeReveableOptions(data) {
        this.setState({
            revealable_options: data
        }, () => {
            // this.validateRevealableoptions();
        })
    }
    editorhandleChangeOptions(data) {
        this.setState({
            options: data
        })
    }

    handleChange = (event: any) => {
        const installedAppName = event.target.name;
        if (installedAppName === "applicationName") {
            this.onApplicationChange(event);
        }
        if (installedAppName === "accountName") {
            this.onAccountChange(event);
        }
        if (installedAppName === "reportName") {
            this.onReportChange(event);
        }
        else {
            const isCheckbox = event.target.type === "checkbox";
            this.setState({
                [event.target.name]: isCheckbox
                    ? event.target.checked
                    : event.target.value
            })
        }
        if (this.nameRef.current.value) {
            this.setState({ nameError: "" });
        }

    }

    validateAccountSelected = () => {
        let accountError = "";
        if (!this.state.accountName || this.state.account_id === 0) {
            accountError = "Account can't be blank";
        }
        if (accountError) {
            this.setState({ accountError: accountError })
            return false;
        }
        if (!accountError) {
            accountError = "";
            this.setState({ accountError: accountError })
            return true;
        }
    }

    validate = () => {
        let nameError = "";
        let applicationError = "";
        let accountError = "";
        let reportError = "";
        if (!this.nameRef.current.value) {
            nameError = "Name can't be blank";
        }

        if (!this.state.applicationName) {
            applicationError = "Application can't be blank";
        }
        if (!this.state.accountName) {
            accountError = "Account can't be blank";
        }
        if (!this.state.reportName) {
            reportError = "Report can't be blank";
        }
        if (this.state.account_id === this.state.report_account_id) {
            accountError = "";
        }

        if (nameError || applicationError || accountError || reportError) {
            this.setState({ nameError: nameError, applicationError: applicationError, accountError: accountError, reportError: reportError })
            return false;
        }
        if (!nameError || !accountError || !applicationError || !reportError) {
            nameError = "";
            applicationError = "";
            accountError = "";
            reportError = "";
            this.setState({ nameError: nameError, applicationError: applicationError, accountError: accountError, reportError: reportError })
            return true;
        }

    }

    validateRevealableoptions() {
        let isValid = ValidateYaml(this.state.revealable_options);
        if (isValid) {
            this.setState({ revealableOptionsError: "" })
            return true;
        }
        if (!isValid) {
            this.setState({ revealableOptionsError: "Revealable Options is not valid please type valid YAML" })
            return false;
        }
    }



    handleSubmit = event => {
        event.preventDefault();
        if (!this.state.isChildUpdate) {
            let invocationSchedules = Array<InvocationSchedulesModel>();
            let invocationSchedulesHealth = Array<InvocationSchedulesHealthModel>();
            this.state.invocation_schedules?.forEach(p => {
                // set default frequency details as daily for time type
                const frequencyDetails: FrequencyDetails =
                    p.frequency_details && p.frequency_details.frequency
                        ? { ...p.frequency_details }
                        : {
                            frequency: "daily",
                            time_of_day: p.run_at_time
                                ? moment(p.run_at_time, "HH:mm").format("hh:mm A")
                                : "",
                            days_of_week: [],
                            days_of_month: [],
                            week_of_month: "",
                        };
                invocationSchedules.push({
                    id: p.id,
                    installed_report_application_id: p.installed_report_application_id,
                    frequency_details: frequencyDetails,
                    run_at_time: p.run_at_time
                });
            });
            this.state.invocation_schedules_health?.forEach(p => {
                // set default frequency details as daily for health type
                const frequencyDetailsHealth: FrequencyDetailsHealth =
                    p.frequency_details && p.frequency_details.frequency
                        ? { ...p.frequency_details }
                        : {
                            frequency: "daily",
                            time_of_day: "",
                            days_of_week: [],
                            days_of_month: [],
                            week_of_month: "",
                        };
                invocationSchedulesHealth.push({
                    id: p.id, report_health: p.report_health, installed_report_application_id: p.installed_report_application_id,
                    frequency_details: frequencyDetailsHealth
                })
            });
            const isValid = this.validate();
            const isrevealableOptionValid = this.validateRevealableoptions();
            let installedApplicationData: InstalledApplicationModel = {
                billable: this.state.billable,
                report_id: this.state.report_id,
                application_id: this.state.application_id,
                name: this.state.name,
                id: this.state.id,
                run_on_report_change: this.state.run_on_report_change,
                enabled: this.state.enabled,
                invocation_schedules: invocationSchedules,
                invocation_schedules_health: invocationSchedulesHealth,
                options: this.state.options,
                revealable_options: this.state.revealable_options
            };

            if (isValid && isrevealableOptionValid) {
                if (installedApplicationData.id === 0) {
                    this.postData(installedApplicationData);
                }
                else {
                    this.updateData(installedApplicationData)
                }
            }
        }
    }

    postData(installedApplication: InstalledApplicationModel) {
        this.setSavingFlag(true);
        this.service.postInstalledApplication(installedApplication)
            .then((res: HttpResponse<InstalledApplicationModel>) => {
                this.setSavingFlag(false);
                if (res && res.result) {
                    this.setState({
                        // installedApplication: res.result,
                        id: res.result.id
                    }, () => {
                        ShowSuccessMessage("Installed Application successfully created.");
                        if (this.state.isSave === ButtonType.Save) {
                            this.props.history.push('/installed-report-application/detail/' + this.state.id);
                            this.setState(this.initialState);
                        }
                        if (this.state.isSave === ButtonType.SaveAndAddAnother) {
                            this.setState(this.initialState);
                            this.props.history.push('/installed-report-application/installed-report-application-form/0');
                        }
                        if (this.state.isSave === ButtonType.SaveAndEdit) {
                            this.props.history.push('/installed-report-application/installed-report-application-form/' + this.state.id);
                            this.setState({ isShowtext: "Edit" })
                        }
                    });

                }
            }, () => {
                this.setSavingFlag(false);
            });;
    }

    updateData(installedApplication: InstalledApplicationModel) {
        this.setSavingFlag(true);
        this.service.updateInstalledApplication(installedApplication)
            .then((res: HttpResponse<InstalledApplicationModel>) => {
                this.setSavingFlag(false);
                if (res && res.result) {
                    this.setState({
                        id: res.result.id
                    }, () => {
                        ShowSuccessMessage("Installed Application successfully updated");
                        if (this.state.isSave === ButtonType.Save) {
                            this.props.history.push('/installed-report-application/detail/' + this.state.id);
                            this.setState(this.initialState);
                        }
                        if (this.state.isSave === ButtonType.SaveAndAddAnother) {
                            this.setState(this.initialState);
                            this.props.history.push('/installed-report-application/installed-report-application-form/0');
                        }
                        if (this.state.isSave === ButtonType.SaveAndEdit) {
                            this.props.history.push('/installed-report-application/installed-report-application-form/' + this.state.id);
                            this.setState({ isShowtext: "Edit" })
                        }
                    });

                }
            }, () => {
                this.setSavingFlag(false);
            });
    }

    handleClick = (event) => {
        this.setState({ isSave: event.target.value, isChildUpdate: false })
    }
    private setSavingFlag(saving: boolean) {
        this.setState({ isSaving: saving });
    }

    //*************** * Accounts************************* //

    onAccountChange = (e) => {
        const value = e.target.value;
        if (value.length > 0) {
            if (this.NetworkCall) {
                clearTimeout(this.NetworkCall);
            }
            this.NetworkCall = setTimeout(() => {
                this.getAccounts(value);
            }, 600);
        }
        this.setState({
            accountName: value,
            account_id: value === "" ? 0 : value,
            accountError: "",
            reportName: "",// clear report input
            report_id: 0,
            reportList: [],
            reportError: ""
        });
    };

    selectedAccount(item) {
        this.setState({
            account_id: item.value,
            accountName: item.text,
            accountList: [],
        });
    }

    renderAccount = () => {
        if (this.state.accountList?.length === 0) {
            return null;
        }
        return (
            <ul className="list-unstyled auto-suggest">
                {this.state.accountList?.map((item, index) => (
                    <li
                        id="account"
                        key={index}
                        onClick={() => this.selectedAccount(item)}
                    >
                        {item.text}
                    </li>
                ))}
            </ul>
        );
    };
    private getAccounts(text: string) {
        this.commonService
            .getAccountsByName(text)
            .then((res: HttpResponse<DropdownItemModel[]>) => {
                if (res) {
                    this.setState({
                        accountList: res.result,
                    });
                }
            });
    }
    //*************** * Accounts************************* //

    //*************** * Reports Start************************* //
    onReportChange = (e) => {
        const value = e.target.value;

        this.setState(
            {
                reportName: value,
                reportError: ""
            },
            () => {
                if (value.length > 0) {
                    if (!this.validateAccountSelected()) {
                        return; // stop if account not selected
                    }
                    if (this.NetworkCall) {
                        clearTimeout(this.NetworkCall);
                    }
                    this.NetworkCall = setTimeout(() => {
                        this.getReports(value);
                    }, 600);
                } else {
                    this.setState({ accountError: "" })
                }
            }
        );
    };

    selectedReport(item) {
        this.setState({
            report_id: item.id,
            reportName: item.name,
            reportList: []
        })
    }

    private getReports(text: string) {
        const accountId: number = this.state.account_id ?? 0;

        this.commonService.getReportsByAccountId(accountId, text)
            .then((res: HttpResponse<ReportsInstalledApplication>) => {
                if (res) {
                    this.setState({
                        reportList: res.result?.reports ?? [],
                        report_account_id: res.result?.id
                    });
                }
            })
            .catch(err => {
                this.setState({ reportList: [] });
            });
    }

    renderReport = () => {
        if (this.state.reportList?.length === 0) {
            return null;
        }
        return (
            <ul className="list-unstyled auto-suggest">
                {
                    this.state.reportList?.map((item, index) => (<li id="report" key={index} onClick={() => this.selectedReport(item)}>{item.name}</li>))
                }
            </ul>
        );
    }
    //*************** * Reports End************************* //


    //*************** * Application Start************************* //

    onApplicationChange = (e) => {
        const value = e.target.value;
        if (value.length > 0) {
            if (this.NetworkCall) {
                clearTimeout(this.NetworkCall);
            }
            this.NetworkCall = setTimeout(() => {
                this.getApplications(value)
            }, 600)
        }
        this.setState({
            applicationName: value,
            applicationError: ""
        }, () => {
            // this.validate();
        })
    }

    selectedApplication(item) {
        this.setState({
            application_id: item.value,
            applicationName: item.text,
            applicationList: []
        })
    }

    renderApplication = () => {
        if (this.state.applicationList?.length === 0) {
            return null;
        }
        return (
            <ul className="list-unstyled auto-suggest">
                {
                    this.state.applicationList?.map((item, index) => (<li id="application" key={index} onClick={() => this.selectedApplication(item)}>{item.text}</li>))
                }
            </ul>
        );
    }

    private getApplications(text: string) {
        this.commonService.getApplicationsByName(text)
            .then((res: HttpResponse<DropdownItemModel[]>) => {
                if (res) {
                    this.setState({
                        applicationList: res.result
                    });
                }
            });

    }

    //*************** * Application End************************* //

    //****************CRUD for frequency with time and health************************* //
    formatTimeTo12Hour = (time24: string): string => {
        if (!time24) return '';

        const [hourStr, minuteStr] = time24.split(':');
        let hour = parseInt(hourStr, 10);
        const minute = minuteStr || '00';
        const ampm = hour >= 12 ? 'PM' : 'AM';

        hour = hour % 12 || 12; // convert 0 - 12 for 12-hour format
        return `${hour}:${minute} ${ampm}`;
    };
    convertTo24Hour(timeStr: string): string {
        if (!timeStr) return "";

        // If already 24-hour format "HH:MM"
        const is24 = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/.test(timeStr);
        if (is24) return timeStr;

        // Convert formats like "2:00 PM", "02:00 am", "2 pm"
        let date = new Date("1970-01-01 " + timeStr);
        if (!isNaN(date.getTime())) {
            return date.toTimeString().slice(0, 5); // "14:00"
        }

        return timeStr; // fallback
    }
    removeInvocationScheduleFreq(index, type: "time" | "health") {
        const listKey =
            type === "time" ? "invocation_schedules" : "invocation_schedules_health";

        const apiService =
            type === "time"
                ? this.serviceInvocationSchedActions
                : this.serviceInvocationHealthActions;

        const successMsg =
            type === "time"
                ? "Invocation Schedule Successfully Deleted."
                : "Invocation Schedule Health Successfully Deleted.";

        const errorMsg =
            type === "time"
                ? "Failed to delete invocation schedule."
                : "Failed to delete invocation schedule health.";

        const list = this.state[listKey];

        if (index === -1 || index == null) return;

        const item = list?.[index];

        // case 1: New unsaved item id is 0
        if (item?.id === 0) {
            const updated = [...(list || [])];
            updated.splice(index, 1);

            this.setState({ [listKey]: updated });
            ShowSuccessMessage(successMsg);
            return;
        }

        // case 2: Saved item -make API call
        if (item?.id && item.id > 0) {
            apiService
                .deleteInvocationScheduleById(item?.id)
                .then((res: HttpResponse<DeleteResponseModel>) => {
                    if (res?.result?.isdeleted) {
                        ShowSuccessMessage(successMsg);

                        const updated = [...(list || [])];
                        updated.splice(index, 1);

                        this.setState({ [listKey]: updated });
                    }
                })
                .catch(() => {
                    ShowErrorMessage(errorMsg);
                });
        }
    }

    editInvocationScheduleFreq(id) {
        const data = this.state.invocation_schedules?.find(p => p.tempId === id);
        if (!data) return;

        this.setState({
            showFreqForm: true,
            invocationScheduleEditedId: id,
            selectedSchedule: data

        });
    }
    editInvocationScheduleHealthFreq(id) {
        const data = this.state.invocation_schedules_health?.find(p => p.tempId === id);
        if (!data) return;

        this.setState({
            showFreqForm: true,
            invocationScheduleHealthEditedId: id,
            selectedSchedule: data

        });
    }
    updateInvocationScheduleFreq(editedData) {
        const { runType, runAtValue, ...frequencyDetails } = editedData;
        const when = runAtValue;

        // Update time of day
        frequencyDetails.time_of_day = moment(when, "HH:mm").format("hh:mm A");

        const sched = this.state.invocation_schedules || [];
        let isDup = this.checkScheduleDuplicate(
            sched,
            frequencyDetails
        );

        if (isDup) {
            ShowWarningMessage("Duplicate time + frequency entry exists.");
            return;
        }

        // Save
        const items = [...this.state.invocation_schedules!];
        const index = items.findIndex(i => i.tempId === this.state.invocationScheduleEditedId);

        items[index] = {
            ...items[index],
            run_at_time: moment(frequencyDetails.time_of_day, "hh:mm A").format("HH:mm"),
            frequency_details: frequencyDetails
        };

        this.setState({
            invocation_schedules: items,
            invocationScheduleEditedId: 0,
            selectedSchedule: null,
        });
    }

    updateInvocationScheduleHealthFreq(editedData) {
        const { runType, runAtValue, ...frequencyDetails } = editedData;
        frequencyDetails.time_of_day = "";



        const sched = this.state.invocation_schedules_health || [];
        let isDup = this.checkScheduleDuplicate(
            sched,
            frequencyDetails
        );

        if (isDup) {
            ShowWarningMessage("Duplicate time and frequency entry exists.");
            return;
        }

        // Save
        const items = [...this.state.invocation_schedules_health!];
        const index = items.findIndex(i => i.tempId === this.state.invocationScheduleHealthEditedId);

        items[index] = {
            ...items[index],
            report_health: runAtValue,
            frequency_details: frequencyDetails
        };

        this.setState({
            invocation_schedules_health: items,
            invocationScheduleHealthEditedId: 0,
            selectedSchedule: null,
        });
    }
    checkScheduleDuplicate(existingList: any[], saveData: any): boolean {
        const {
            runAtValue,
            days_of_week,
            days_of_month,
            week_of_month,
            time_of_day,
            frequency
        } = saveData;

        // normalize new frequency details
        const newDays = Array.isArray(days_of_week)
            ? [...days_of_week].sort()
            : days_of_week ? [days_of_week] : [];

        const newDates = Array.isArray(days_of_month)
            ? [...days_of_month].sort()
            : days_of_month ? [days_of_month] : [];

        const newWeek = week_of_month || "";

        // time value for duplicate check (lowercased)
        const newTimeOrHealth = (runAtValue || time_of_day || "").trim().toLowerCase();

        // normalize existing frequency details
        const normalizeExisting = (item: any) => {
            const fd = item.frequency_details || {};

            return {
                frequency: fd.frequency || "",
                days: Array.isArray(fd.days_of_week)
                    ? [...fd.days_of_week].sort()
                    : fd.days_of_week ? [fd.days_of_week] : [],
                dates: Array.isArray(fd.days_of_month)
                    ? [...fd.days_of_month].sort()
                    : fd.days_of_month ? [fd.days_of_month] : [],
                week: fd.week_of_month || "",


                // if time - check run_at_time or freq time_of_day
                // if health - check report_health or freq time_of_day
                value: String(
                    item.run_at_time ||
                    item.report_health ||
                    fd.time_of_day ||
                    ""
                )
                    .trim()
                    .toLowerCase(),
            };
        };

        // duplicate check
        return existingList.some((item) => {
            const ex = normalizeExisting(item);

            if (ex.frequency !== frequency) return false;

            const sameDays = JSON.stringify(ex.days) === JSON.stringify(newDays);
            const sameDates = JSON.stringify(ex.dates) === JSON.stringify(newDates);
            const sameWeek = ex.week === newWeek;
            const sameValue = ex.value === newTimeOrHealth;

            // Require time/health + all frequency fields
            return sameDays && sameDates && sameWeek && sameValue;
        });
    }

    createInvocationschedulesFreq = (saveData: any) => {
        const { runType, runAtValue } = saveData;
        const sched = this.state.invocation_schedules || [];
        const schedHealth = this.state.invocation_schedules_health || [];


        if (runType === "time") {


            const frequency_details = {
                frequency: saveData.frequency,
                days_of_week: saveData.days_of_week,
                days_of_month: saveData.days_of_month,
                week_of_month: saveData.week_of_month,
                time_of_day: moment(runAtValue, "HH:mm").format("hh:mm A"),
            };

            let isDup = this.checkScheduleDuplicate(
                sched,
                saveData
            );

            if (isDup) {
                ShowWarningMessage("Duplicate time and frequency entry exists.");
                return;
            }
            const newItem = {
                id: 0,
                tempId: sched.length + 1,
                installed_report_application_id: this.state.id,
                run_at_time: runAtValue,
                frequency_details
            };

            this.setState({
                invocation_schedules: [...sched, newItem]
            });
        }
        if (runType === "health") {
            const frequency_details = {
                frequency: saveData.frequency,
                days_of_week: saveData.days_of_week,
                days_of_month: saveData.days_of_month,
                week_of_month: saveData.week_of_month,
                time_of_day: '',
            };
            let isDupHealth = this.checkScheduleDuplicate(
                schedHealth,
                saveData
            );

            if (isDupHealth) {
                ShowWarningMessage("Duplicate health + frequency entry exists.");
                return;
            }
            const newItem = {
                id: 0,
                tempId: schedHealth.length + 1,
                installed_report_application_id: this.state.id,
                report_health: runAtValue,
                frequency_details
            };
            this.setState({
                invocation_schedules_health: [...schedHealth, newItem]
            });
        }
    };

    render() {
        return (
            <Fragment>
                <form onSubmit={this.handleSubmit}>
                    <input type="hidden" value={this.state.id} />
                    <div>
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <h5 className="installed-app-title">{this.state.isShowtext} Installed Application {this.state.name && <span> '{this.state.name}'</span>}</h5>
                        </div>
                        <Modal backdrop="static" keyboard={false} size="lg" show={this.state.showAccountForm} onHide={this.handleClose}>
                            <AccountFormPopup
                                updateAccount={this.updateAccount}
                                handleClose={this.handleCloseAccount}
                                isNew={this.state.isNew}
                                id={this.state?.account_id}
                            />
                        </Modal>
                        <Modal backdrop='static' keyboard={false} size="lg" show={this.state.showReportForm} onHide={this.handleClose}>
                            <ReportFormPopup updateReport={this.updateReport} handleClose={this.handleClose} isNew={this.state.isNew} id={this.state?.report_id} />
                        </Modal>
                        <Modal backdrop='static' keyboard={false} size="lg" show={this.state.showApplicationForm} onHide={this.handleCloseApplication}>
                            <ApplicationsFormPopup updateApplication={this.updateApplication} handleClose={this.handleCloseApplication} isNew={this.state.isNew} id={this.state?.application_id} />
                        </Modal>
                        <div className="row">
                            <div className="col-md-12 col-xl-12">
                                <div className="card">
                                    <div className="card-body">
                                        {this.props.match.params.id != 0 && <InstalledApplicationTabs id={this.props.match.params.id} url="/installed-report-application/installed-report-application-form/" />}
                                        <div className="row">
                                            <div className="col-xl-3 col-md-3">
                                                <div className="form-group">
                                                    <label>Name<span className=" text-danger">*</span></label>
                                                    <input type="text" ref={this.nameRef} maxLength={255} name="name" value={this.state.name} placeholder="Enter Name" onChange={this.handleChange} className={!this.state.nameError ? 'form-control' : 'form-control  is-invalid'} />
                                                    {/* <div className="hint-text">Required. Length up to 255.</div> */}
                                                    <div className="invalid-feedback">
                                                        {this.state.nameError}
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-3 col-md-3">
                                                <div className="form-group">
                                                    <label>Account<span className="text-danger">*</span></label>
                                                    <div className="input-group mb-3">
                                                        <input autoComplete="off" placeholder="Search" id="accountName" name="accountName" type="text" onChange={this.handleChange} value={this.state.accountName}
                                                            className={!this.state.accountError ? 'form-control' : 'form-control  is-invalid'} />
                                                        {this.renderAccount()}
                                                        {IsAuthorize([Role.TAM, Role.Dev, Role.Support]) && <div className="input-group-append">
                                                            <button type="button" className="btn btn-success" onClick={this.handleShowAccount}><i className="fas fa-plus" style={{ color: "white" }}></i></button>
                                                            <button type="button" className={`btn btn-primary`} disabled={this.state.account_id == 0} onClick={this.handleShowEditAccount}><i className="far fa-edit"></i></button>
                                                        </div>}
                                                        <div className="invalid-feedback" >
                                                            {this.state.accountError}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-3 col-md-3">
                                                <div className="form-group">
                                                    <label>Report<span className="text-danger">*</span></label>
                                                    <div className="input-group mb-3">
                                                        <input autoComplete="off" placeholder="Search" id="reportName" name="reportName" type="text" onChange={this.handleChange} value={this.state.reportName}
                                                            className={!this.state.reportError ? 'form-control' : 'form-control  is-invalid'} />
                                                        {this.renderReport()}
                                                        {IsAuthorize([Role.TAM, Role.Dev, Role.Support]) && <div className="input-group-append">
                                                            <button type="button" className={`btn btn-primary ${this.state?.report_id == 0 || null ? "disabled" : ""}`} onClick={this.handleShowEditReport}><i className="far fa-edit"></i></button>
                                                        </div>}
                                                        <div className="invalid-feedback" >
                                                            {this.state.reportError}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-xl-3 col-md-3">
                                                <div className="form-group mb-2 position-relative">
                                                    <label>Application<span className=" text-danger">*</span></label>
                                                    <div className="input-group mb-3">
                                                        <input autoComplete="off" placeholder="Search" id="applicationName" name="applicationName" type="text" onChange={this.handleChange} value={this.state.applicationName}
                                                            className={!this.state.applicationError ? 'form-control' : 'form-control  is-invalid'} />
                                                        {this.renderApplication()}
                                                        <div className="input-group-append">
                                                            <button type="button" className="btn btn-success" onClick={this.handleShowApplication}><i className="fas fa-plus" style={{ color: "white" }}></i></button>
                                                            <button type="button" className={`btn btn-primary`} disabled={this.state.application_id == 0} onClick={this.handleShowEditApplication}><i className="far fa-edit"></i></button>
                                                        </div>
                                                        <div className="invalid-feedback">
                                                            {this.state.applicationError}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row mt-4">
                                            <div className="col-md-6">
                                                <div className="form-group shadow-sm p-3 mb-4 ">

                                                    <div className="custom-control custom-checkbox">
                                                        <input type="checkbox" name="enabled" checked={this.state.enabled} onChange={this.handleChange} className="custom-control-input" id="enabled" />
                                                        <label className="custom-control-label" htmlFor="enabled">Enabled</label>
                                                    </div>
                                                    <small >This instance of the app will not run under any circumstances</small>
                                                </div>
                                                <div className="form-group  shadow-sm p-3 mb-4 ">

                                                    <div className="custom-control custom-checkbox">
                                                        <input type="checkbox" name="run_on_report_change" checked={this.state.run_on_report_change} onChange={this.handleChange} className="custom-control-input" id="run_on_report_change" />
                                                        <label className="custom-control-label" htmlFor="run_on_report_change">Run On Report Change</label>
                                                    </div>
                                                    <small>The app will run automatically every time the report changes.</small>
                                                </div>
                                                <div className="form-group  shadow-sm p-3 mb-0 ">

                                                    <div className="custom-control custom-checkbox">
                                                        <input type="checkbox" name="billable" checked={this.state.billable} onChange={this.handleChange} className="custom-control-input" id="Billable" />
                                                        <label className="custom-control-label" htmlFor="Billable">Billable</label>
                                                    </div>
                                                    <small>If this is true, the app will billable.</small>
                                                </div>

                                            </div>
                                            <div className="col-md-6 shadow-sm ">
                                                {/* Invocation Freq tabl */}
                                                <div className='row'>
                                                    <div className='col-md-12 form-group'>
                                                        <div className="d-flex flex-column align-items-end mb-2 mt-2">
                                                            <div

                                                                title='Add frequency for Run At Time/Health'
                                                            >
                                                                <button
                                                                    type="button"
                                                                    onClick={this.handleShowFreqModal}
                                                                    className="btn btn-success"
                                                                >
                                                                    <i className="fas fa-plus"></i> Add Configuration
                                                                </button>
                                                            </div>
                                                            <small>
                                                                This will set frequency for time schedule and health
                                                            </small>
                                                        </div>
                                                    </div>

                                                    <Modal
                                                        backdrop="static"
                                                        keyboard={false}
                                                        size="sm"
                                                        show={this.state.showFreqForm}
                                                        onHide={this.handleCloseFreqForm}
                                                    >
                                                        <FrequencyFormPopup
                                                            handleClose={this.handleCloseFreqForm}
                                                            editData={this.state.selectedSchedule}
                                                            onSave={(data) => {

                                                                if (this.state.invocationScheduleEditedId === 0 && this.state.invocationScheduleHealthEditedId === 0) {
                                                                    // create — add new one
                                                                    this.createInvocationschedulesFreq(data);
                                                                } // edit — update existing item
                                                                else if (this.state.invocationScheduleEditedId !== 0) {
                                                                    if (data.runType == 'time')
                                                                        this.updateInvocationScheduleFreq(data);
                                                                } else if (this.state.invocationScheduleHealthEditedId !== 0) {
                                                                    if (data.runType == 'health')
                                                                        this.updateInvocationScheduleHealthFreq(data);
                                                                }

                                                                this.handleCloseFreqForm();
                                                            }}
                                                        />
                                                    </Modal>
                                                    <div className="col-xl-12 col-md-12" >
                                                        <div className="table-container">
                                                            <table className="table table-striped table-sm mb-0 text-center invoSchedule-table">
                                                                <thead>
                                                                    <tr>
                                                                        <th>Type</th>
                                                                        <th>When?</th>
                                                                        <th>Frequency</th>
                                                                        <th>Action</th>
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {/* TIME-BASED SCHEDULES FIRST */}
                                                                    {this.state.invocation_schedules?.map((item, index) => {
                                                                        const freq = item.frequency_details;

                                                                        let scheduleText = getFrequencyText(freq)

                                                                        return (
                                                                            <tr key={`time-${index}`}>
                                                                                <td>Time</td>
                                                                                <td>{moment(item.run_at_time, "hh:mm A").format("HH:mm")|| moment(item.frequency_details?.time_of_day, "hh:mm A").format("HH:mm")}</td>
                                                                                <td>{scheduleText}</td>
                                                                                <td>
                                                                                    <Link
                                                                                        className="btn btn-sm far fa-edit"
                                                                                        onClick={() => this.editInvocationScheduleFreq(item.id ? item.id : item.tempId)}
                                                                                    ></Link>
                                                                                    &nbsp;
                                                                                    <Link
                                                                                        className="btn btn-sm far fa-trash-alt"
                                                                                        onClick={() => this.removeInvocationScheduleFreq(index, 'time')}
                                                                                    ></Link>
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })}
                                                                    {/* HEALTH-BASED SCHEDULES NEXT */}
                                                                    {this.state.invocation_schedules_health?.map((item, index) => {
                                                                        const freq = item.frequency_details;

                                                                        let scheduleText = getFrequencyText(freq);

                                                                        return (
                                                                            <tr key={`health-${index}`}>
                                                                                <td>Health</td>
                                                                                <td>{item.report_health}</td>
                                                                                <td>{scheduleText}</td>

                                                                                <td>
                                                                                    <Link
                                                                                        className="btn btn-sm far fa-edit"
                                                                                        onClick={() => this.editInvocationScheduleHealthFreq(item.id ? item.id : item.tempId)}
                                                                                    ></Link>
                                                                                    &nbsp;
                                                                                    <Link
                                                                                        className="btn btn-sm far fa-trash-alt"
                                                                                        onClick={() => this.removeInvocationScheduleFreq(index, 'health')}
                                                                                    ></Link>
                                                                                </td>
                                                                            </tr>
                                                                        );
                                                                    })}
                                                                </tbody>

                                                            </table>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="row  mt-5">
                                            <div className="col-xl-6 col-lg-12 col-md-12 mb-5">
                                                <h5>Revealable Options</h5>
                                                <label className="small">Provides non-sensitive details and control options to the application (NOT ENCRYPTED)</label>
                                                <Editor StringData={this.state.revealable_options} FormateType="yaml" onChange={this.editorhandleChangeReveableOptions} />
                                                {this.state.revealableOptionsError != "" && <div style={{ color: 'red' }}>
                                                    {this.state.revealableOptionsError}
                                                </div>}
                                            </div>
                                            <div className="col-xl-6 col-lg-12 col-md-12">
                                                <h5>Options</h5>
                                                <label className="small">Provides authentication details and other control options for the application (ENCRYPTED)</label>
                                                <Editor StringData={this.state.options} FormateType="yaml" onChange={this.editorhandleChangeOptions} />
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        <div className="text-center mt-3 mb-4">
                            <Link type="button" className="btn btn-lg btn-default" to="/installed-report-application/list">{ButtonType.Cancel}</Link>
                            {!this.state.isSaving && <Fragment>
                                <input type="submit" className="btn btn-lg btn-primary  ml-3" onClick={this.handleClick} value={ButtonType.Save} />
                                <input type="submit" className="btn btn-lg btn-primary  ml-3" value={ButtonType.SaveAndAddAnother} onClick={this.handleClick} />
                                <input type="submit" className="btn btn-lg btn-primary  ml-3" value={ButtonType.SaveAndEdit} onClick={this.handleClick} />
                            </Fragment>
                            }
                            <Loader loading={this.state.isSaving} marginBottom="0px" marginTop="8px" width="368px" ></Loader>
                        </div>
                    </div>
                </form>
            </Fragment>
        )
    }
}